import React, { ComponentProps } from 'react';
import { ContentList, ContentListItem } from '../../../_lib/components/ContentList';
import { ContentHeadline } from '../../../_lib/components/ContentHeadline';
import { murmurhash } from '../../../lib/js/hash';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { translatePageType } from '../../../_lib/components/PageType/PageTypeTitle';
import { PageType } from '../../../types/api/PageType';
import { AttributeRuleCombination, AttributeRules } from '../../../_lib/components/AttributeRules/AttributeRules';
import { AttributeRule } from '../../../types/api/AttributeGroups';
import { asView } from '../../../_lib/ViewFetcher';
import { ContentHeadlineModifier } from '../../../_lib/components/ContentHeadline/ContentHeadline';

type PageMembershipMatchingRuleListProps = {
  pageMembershipMatchingRules?: Array<{
    areaPageType: PageType;
    roleName: string;
    ruleUrl: string;
    rules: AttributeRule[];
    ruleCombination?: AttributeRuleCombination;
  }>;
};

function PageMembershipMatchingRuleList({ pageMembershipMatchingRules }: PageMembershipMatchingRuleListProps) {
  const { t } = useSonTranslation('PageMembershipMatchingRuleList');

  if (!pageMembershipMatchingRules || pageMembershipMatchingRules.length === 0) {
    return null;
  }

  const transformRules = (rules: AttributeRule[]) =>
    rules.map(rule => ({
      ...rule,
      conditionValue: rule.conditionValue ? rule.conditionValue : t('areaMatchingRule'),
    }));

  return (
    <ContentList ordered>
      {pageMembershipMatchingRules.map((ruleItem, index) => (
        <ContentListItem key={index}>
          <ContentHeadline
            title={t('title', {
              areaPageType: translatePageType(ruleItem.areaPageType),
              roleName: ruleItem.roleName,
            })}
            url={ruleItem.ruleUrl}
            hierarchy={2}
            modifier={ContentHeadlineModifier.TOP_HEADLINE}
            headingId={`page-membership-matching-rule-list-heading-${murmurhash(ruleItem.ruleUrl)}`}
          />
          <AttributeRules
            rules={transformRules(ruleItem.rules)}
            heading={t('ruleHeading')}
            ruleCombination={pageMembershipMatchingRules[0].ruleCombination}
          />
        </ContentListItem>
      ))}
    </ContentList>
  );
}

export const PageMembershipMatchingRulesDefaultView = asView(PageMembershipMatchingRuleList);
export type PageMembershipMatchingRulesDefaultView = ComponentProps<typeof PageMembershipMatchingRuleList>;
